/**
 * Lumicle Enerji Kullanım Tarifesi (statik).
 * Marker rengi `PowerTier`'a göre (AC / DC_FAST / DC_ULTRA);
 * fiyatlandırma ise sadece AC ve DC olarak iki dilim.
 */

export type TariffKey = "AC" | "DC";

export interface TariffEntry {
  price: number;
  currency: "TRY" | "EUR" | "USD";
  vatIncluded: boolean;
}

export const TARIFFS: Record<TariffKey, TariffEntry> = {
  AC: { price: 9.99, currency: "TRY", vatIncluded: true },
  DC: { price: 13.49, currency: "TRY", vatIncluded: true },
};

export const TARIFF_LABELS: Record<TariffKey, { tr: string; en: string }> = {
  AC: {
    tr: "AC Enerji Kullanım Tarifesi",
    en: "AC Energy Tariff",
  },
  DC: {
    tr: "DC Enerji Kullanım Tarifesi",
    en: "DC Energy Tariff",
  },
};
